import { render, staticRenderFns } from "./RewardChangeHistoryModal.vue?vue&type=template&id=35e43b30&scoped=true"
import script from "./RewardChangeHistoryModal.vue?vue&type=script&lang=js"
export * from "./RewardChangeHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e43b30",
  null
  
)

export default component.exports